import { render } from "./Istatistik.vue?vue&type=template&id=bcc16d08"
import script from "./Istatistik.vue?vue&type=script&lang=js"
export * from "./Istatistik.vue?vue&type=script&lang=js"

import "./Istatistik.vue?vue&type=style&index=0&id=bcc16d08&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__